import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const Piechart = ({ orders }) => {
  const [series, setSeries] = useState([0, 0, 0]);

  useEffect(() => {
    //success , pending , failure , shipped ,

    const cancelledOrders = orders.filter(
      (order) => order?.order_status === "cancelled"
    );
    const cancelledOrder = orders.filter(
      (order) => order?.order_status === "cancel"
    );
    const pendingOrders = orders.filter(
      (order) => order?.order_status === "pending"
    );
    const successOrders = orders.filter(
      (order) => order?.order_status === "confirmed"
    );

    const failureOrders = orders.filter(
      (order) => order?.order_status === "failure"
    );
    const shippedOrders = orders.filter(
      (order) => order?.order_status === "shipped"
    );

    // setSeries([cancelledOrders.length + cancelledOrder.length, pendingOrders.length, successOrders.length]);
    setSeries([
      failureOrders.length,
      pendingOrders.length,
      shippedOrders.length,
    ]);
  }, [orders]);

  const [options] = useState({
    chart: {
      width: 380,
      type: "pie",
    },
    // labels: ["Cancelled", "Pending", "Success"],
    labels: ["Failed", "Pending", "Success"],
    legend: {
      position: "bottom",
      markers: {
        fillColors: ["red", "#f9c500", "#719924"],
      },
    },
    fill: {
      colors: ["#B22222", "#fccc55", "#719924"],
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="pie"
          width="100%"
        />
      </div>
    </div>
  );
};

export default Piechart;
